module.exports = __webpack_public_path__ + "img/r2.7d638b01.png";